import { render, staticRenderFns } from "./api_token.vue?vue&type=template&id=6188476e&scoped=true&"
import script from "./api_token.vue?vue&type=script&setup=true&lang=ts&"
export * from "./api_token.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6188476e",
  null
  
)

export default component.exports